
// Checkout JS file that is compiled via Webpack - ALS 
import { fflToggle } from "./custom/utils/toggles";
import {
    shippingSaveReloadSidebar,
    paymentSaveReloadSidebar,
    refreshCartSidebar,
    refreshSidebarTotalsOnly,
    refreshCartAfterShippingMethod,
    bindSidebarTotalsFromResponse,
    bindAfterShippingMethodRefreshCart
} from "./custom/checkout/reloads";
import { jsEventLog } from "./custom/utils/log";
import { hideSearch } from "./custom/checkout/hideSearch";
import { handleProductWarranty } from "./custom/checkout/warranty";
import { checkoutFunctionality } from "./custom/checkout/functionality";
import { refreshMiniCart } from "./custom/checkout/minicart";
import { inputMaskCredova } from "./custom/form/credova";

window.shippingSaveReloadSidebar = shippingSaveReloadSidebar;
window.paymentSaveReloadSidebar = paymentSaveReloadSidebar;
window.handleProductWarranty = handleProductWarranty;
window.refreshMiniCart = refreshMiniCart;
window.refreshCartSidebar = refreshCartSidebar;
window.refreshSidebarTotalsOnly = refreshSidebarTotalsOnly;
window.refreshCartAfterShippingMethod = refreshCartAfterShippingMethod;
window.bindSidebarTotalsFromResponse = bindSidebarTotalsFromResponse;
window.bindAfterShippingMethodRefreshCart = bindAfterShippingMethodRefreshCart;
window.inputMaskCredova = inputMaskCredova;

// ------ misc scripts  ------ //

// On Ready 
jQuery(function($) { 
    fflToggle();
    handleProductWarranty();
    checkoutFunctionality();
    hideSearch();
    jsEventLog();

    bindSidebarTotalsFromResponse();
    bindAfterShippingMethodRefreshCart();

    // Warm the order summary the same way warranty add does: force miniCart
    // collectTotals + paint. Cold sessions otherwise SSR subtotal-only until
    // a later shipping-step refresh (and that first pass was flaky).
    if ($('#sidebar-order-totals').length) {
        refreshSidebarTotalsOnly();
    }

    // Scroll to input when validation fails
    scrollToInput('#shipping-buttons-container .button');

    // Scroll to input when validation fails
    scrollToInput('#billing-buttons-container .button');
});




